import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { UserService } from '../api/user.service';
import { JwtService } from '../../jwt/jwt.service';

@Injectable()
export class LoginGuard implements CanActivate {
  constructor(private router: Router, private userService: UserService, private jwtService: JwtService) {}

  canActivate() {

    if (!this.jwtService.checkAccessToken()) {
      return true;
    }

    this.router.navigate(['/']);

    return false;
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/common/guard/login.guard.ts